export function formatCurrency(amount) {
  if (amount == null || isNaN(amount)) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function formatDate(isoString) {
  if (!isoString) return '-';
  try {
    const d = typeof isoString === 'number' && isoString < 1e12
      ? new Date(isoString * 1000)
      : new Date(isoString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(d);
  } catch {
    return String(isoString);
  }
}

export function formatDateShort(isoString) {
  if (!isoString) return '-';
  try {
    const d = typeof isoString === 'number' && isoString < 1e12
      ? new Date(isoString * 1000)
      : new Date(isoString);
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(d);
  } catch {
    return String(isoString);
  }
}

export function formatStatus(status) {
  if (!status) return '-';
  return status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
